import { AttivitaDTO } from "@api/client";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

interface Props {
	item: AttivitaDTO | undefined;
}

const ModalActivityOrdersItem: React.FC<Props> = (props) => {
	const { item } = props;

	const {
		attributes,
		listeners,
		setNodeRef,
		transform,
		transition,
		isDragging,
	} = useSortable({ id: item?.id! });

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
	};

	return (
		<li
			ref={setNodeRef}
			{...attributes}
			{...listeners}
			style={style}
			className={`card mb-2 hover:cursor-grab active:cursor-grabbing transition-all duration-200 overflow-hidden ${
				isDragging ? "opacity-50" : ""
			}`}
		>
			<div className="card-body p-3 flex flex-row items-center  bg-slate-200">
				<div className="avatar me-2">
					<div className="w-12 rounded">
						<img src={`data:image/jpg;base64,${item?.image?.data}`} />
					</div>
				</div>

				<b>{item?.name}</b>
			</div>
		</li>
	);
};
export default ModalActivityOrdersItem;
